import api from "../apis/selectree_api";
import { getAuthHeader } from "../utilities/header";

export function linkExternalResources(
  tree_id,
  external_resource_id,
  href,
  name = null
) {
  return async dispatch => {
    return api
      .post(
        `/tree/${tree_id}/external_resources/${external_resource_id}`,
        { href, name },
        getAuthHeader()
      )
      .then(
        response => {
          dispatch({
            type: "TREE_DETAIL_UPDATE",
            payload: { external_resources: response.data },
          });
          return response;
        },
        error => error.response
      );
  };
}
